<template>
  <div class="document-container">
    <div class="doc-name">
      <p class="name">支付订单</p>
      <p class="update-time">{{currentParams.updateTime}}</p>
    </div>
    <div class="request-module-box">
      <div class="module-name">
        <span>支付说明</span>
      </div>
      <div class="module-text">
        <span>1、油柑网会在您完成支付之后发货。</span>
      </div>
      <div class="module-text">
        <span>2、由于目前油柑网开放平台没有开放直接调用第三方支付平台支付的接口，所以现有的方案是通过服务您的业务员来代为支付的。</span>
      </div>
      <div class="module-text">
        <span>3、在接入油柑网开放平台后，会有一名业务员专门负责与您对接，我们推荐您在油柑网首先预存一笔备用金，然后在生成订单后，联系对接您的业务员，由他代为支付订单。您也可以在生成订单后，通过转账的方式将订单所需款项转给对接您的业务员，再由他代为支付订单。详细的流程如下图。</span>
      </div>
      <div class="module-text">
        <span>4、您可以通过调取订单详情接口来获取订单的状态信息，但是我们推荐您构建自己的订单列表和订单详情来维护订单信息。</span>
      </div>
      <div class="module-text">
        <span>5、如果您需要取消订单，加急发货，退货换货等服务，也需要联系对接您的业务员来处理。</span>
      </div>
      <div class="module-img">
        <img src="../../../../assets/images/pay-step.png" />
      </div>
    </div>
  </div>
</template>
<script>
import Tables from "@/components/Tables";
import publicData from "@/api/public/index";
import { createOrderApi } from "@/api/order/index";
export default {
  components: {
    Tables
  },
  data() {
    return {
      publicParams: publicData,
      currentParams: createOrderApi
    };
  }
};
</script>
<style lang="less" scoped>
.document-container {
  padding: 0 40px;
  text-align: left;
  .doc-name {
    border-bottom: 1px solid #dedede;
    > .name {
      font-size: 24px;
      text-align: left;
      color: #333;
    }
    > .update-time {
      margin-top: 10px;
      margin-bottom: 30px;
      font-size: 12px;
      color: #666666;
    }
  }
  .request-module-box {
    .module-name {
      height: 60px;
      font-size: 16px;
      line-height: 60px;
      color: #333;
    }
    .table-box {
    }
    .module-text {
      font-size: 14px;
      line-height: 40px;
      text-align: justify;
      a {
        color: #4fbfff;
        text-decoration: underline;
      }
    }
    .module-img {
      margin-top: 10px;
      img {
        width: 100%;
        display: block;
      }
    }
    .code-example {
      background-color: #e8e8e8;
    }
  }
}
</style>